<template>
    <div id="interiorDesign_wrapper">
        <div id="interiorDesign">
            <section style="overflow-x: hidden!important" class="stipple-bg">
                <b-container class="header d-md-flex flex-column justify-content-center nav-padding">
                    <b-row>
                        <b-col md="7" class="pr-md-0">
                            <img src="/img/design-and-style.svg" alt="Pride and Joy" class="w-100 d-block max-w-500 h-auto" width="500" height="375">
                            <p class="gotham-book mb-0 mt-5 fade-in-up-element">
                                Interior Design is the department that makes your model homes, common areas, sales & presentation spaces look like they should be on the cover of Elle Decor. Veterans of the new and students of the timeless, our in-house design team has a unique perspective on the limitless and ever-changing world of style. Their visions create spectacular spaces that sell, and their unparalleled sense of style has made so many award-winning.
                            </p>
                        </b-col>
                        <b-col md="5" class="">
                            <nuxt-img provider="static" format="webp"
                                src="/img/interior-design/interior-design-meshed-chair.png" 
                                alt="Meshed Chair" 
                                class="d-block w-100 h-auto"
                                width="445" 
                                height="466"
                                sizes="xs:100vw sm:100vw lg:445px"
                            />
                        </b-col>
                    </b-row>
                </b-container>
            </section>
            <!--  -->

            <section class="stipple-bg">
                <b-container fluid class="bg-black pt-30 pb-30">
                    <b-container class="custom-container-1600">
                        <b-row>
                            <b-col md="6">
                                <div class="d-flex flex-column">
                                    <!-- <img src="/img/quotes-left-white.png" alt="Quotes" class="w-100 d-inline-block max-w-200 lg-quotes">
                                    <p class="fade-in-up-element text-white gotham-book mt-4 lg-text">
                                        Subject influences style. Style influences design. Design influences sales.
                                    </p>
                                    <img src="/img/quotes-right-white.png" alt="Quotes" class="w-100 d-inline-block max-w-200 ml-auto lg-quotes"> -->
                                    <img src="/img/interior-design/subject-influence.svg" alt="Subject Influence" class="w-100">
                                </div>
                            </b-col>
                            <b-col md="6" class="overflow-hidden mt-md-0 mt-4">
                                <TextWheel3D />
                            </b-col>
                        </b-row>
                    </b-container>
                </b-container>
            </section>
            <section class="stipple-bg">
                <b-container class="pt-5">
                    <!--  -->
                    <b-row class="mt-70">
                        <b-col cols="6" class="d-md-flex justify-content-between flex-column">
                            <div class="fade-in-up-element overflow-hidden">
                                <nuxt-img provider="static" format="webp"
                                src="/img/interior-design/interior-design-vase.png" 
                                width="445"
                                height="555"
                                alt="Vase" 
                                class="w-100 d-block h-auto"
                               />
                            </div>
                        </b-col>
                        <b-col cols="6" class="d-md-flex flex-column justify-content-end mt-5">
                            <div class="mt-5 fade-in-up-element">
                                <div class="overflow-hidden h-100">
                                    <nuxt-img provider="static" format="webp"
                                    src="/img/interior-design/interior-design-fireplace.jpg" 
                                    alt="Fireplace" 
                                    class="w-100 d-block plax-img max-w-440"
                                    width="492"
                                    height="841" />
                                </div>
                                <nuxt-img provider="static" format="webp"
                                src="/img/guidelines-circular-stamp-pink.png" alt="Guidelines 1063" class="ga-circular-stamp fade-in-up-element h-auto"
                                width="280"
                                height="282"/>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-100">
                        <p class="fade-in-up-element gotham-book h4 px-4 px-md-0">
                            Looks matter. That's not superficial. That's sales. But looks alone can only get you so far. This is why our Interior Design department takes great care to ensure that every element of every model home, common area, sales and presentation space is considered to create a comprehensive sales tool. From the budget and planning stages to materials selection and installation, they'll work with you throughout the entire process to bring your vision to life and help it reach its highest potential. Their holistic approach to interior design will accentuate your product's best benefits -- empowering it by creating a real-life experience that can be touched, seen, and savoured. 
                        </p>
                    </b-row>
                </b-container>
            </section>
            <!--  -->
            <section class="stipple-bg pt-100 conclusion">
                <SliderLarge :largeSlides="largeSlides"/>
                <b-container class="pt-120">
                    <b-row>
                        <b-col md="8">
                            <InteriorDesignTabOne />
                        </b-col>
                        <b-col md="4" class=" pl-md-5">
                            <nuxt-img 
                                loading="lazy" 
                                provider="static" 
                                format="webp"
                                src="/img/quotes-left.png" 
                                alt="Quotations"
                                class="d-block max-w-40"
                                width="40"
                                height="31"
                                sizes="lg:41px"
                            />
                            <p class="h4 mt-4 fade-in-up-element">
                                Words on a page & pictures on a website can be powerful. Experiencing something for yourself is beyond compare.
                            </p>
                            <div class="d-flex justify-content-between">
                                <nuxt-img 
                                    loading="lazy" 
                                    provider="static" 
                                    format="webp"
                                    src="/img/quotes-right.png" 
                                    alt="Quotations"
                                    class="d-block max-w-40 w-100 h-100 ml-auto"
                                    width="40"
                                    height="31"
                                    sizes="lg:41px"
                                />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-70 px-md-5">
                        <b-col cols="6" class="d-md-flex justify-content-between flex-column position-relative pr-md-4">
                            <div class="fade-in-up-element overflow-hidden">
                                <nuxt-img provider="static" format="webp"
                                src="/img/interior-design/interior-design-family-room.jpg" 
                                alt="Deco Homes" 
                                class="w-100 d-block plax-img h-auto"
                                width="492"
                                height="653"/>
                            </div>
                            <nuxt-img provider="static" format="webp"
                                src="/img/guidelines-circular-stamp-pink.png" alt="Guidelines 1063" class="ga-circular-stamp-2 fade-in-up-element d-none d-md-block"
                                width="280"
                                height="282"/>
                            
                        </b-col>
                        <b-col cols="6" class="pl-md-5 d-md-flex flex-column justify-content-center">
                            <div class="fade-in-up-element overflow-hidden">
                                <nuxt-img provider="static" format="webp"
                                src="/img/interior-design/interior-design-teepee-bed.jpg" 
                                alt="Deco" 
                                class="w-100 d-block plax-img max-w-420"
                                width="459"
                                height="507"/>
                            </div>
                        </b-col>

                    </b-row>

                    <b-row class="mt-100">
                        <b-col md="4" class="pr-md-5">
                            <nuxt-img 
                                loading="lazy" 
                                provider="static" 
                                format="webp"
                                src="/img/quotes-left.png" 
                                alt="Quotations"
                                class="d-block max-w-40"
                                width="40"
                                height="31"
                                sizes="lg:41px"
                            />
                            <p class="h4 mt-4 fade-in-up-element">
                                From floor plan drafting to final finish, we're with you every step of the way.
                            </p>
                            <div class="d-flex justify-content-between">
                                <nuxt-img 
                                    loading="lazy" 
                                    provider="static" 
                                    format="webp"
                                    src="/img/quotes-right.png" 
                                    alt="Quotations"
                                    class="d-block max-w-40 w-100 h-100 ml-auto"
                                    width="40"
                                    height="31"
                                    sizes="lg:41px"
                                />
                            </div>
                        </b-col>
                        <b-col md="8">
                            <InteriorDesignTabTwo />
                        </b-col>
                    </b-row>

                    <b-row class="mt-70">
                        <b-col cols="6" class="d-md-flex justify-content-between flex-column justify-content-md-end align-items-md-end  mb-md-5">
                            <div class="fade-in-up-element overflow-hidden">
                                <nuxt-img provider="static" format="webp"
                                src="/img/interior-design/interior-design-southport-1.jpg" 
                                alt="Southport" 
                                class="w-100 d-block plax-img pr-md-5"/>
                            </div>
                        </b-col>
                        <b-col cols="6" class="d-md-flex flex-column justify-content-center pl-md-4 mt-md-5">
                            <div class="fade-in-up-element overflow-hidden mt-md-5 mt-0">
                                <nuxt-img provider="static" format="webp"
                                src="/img/interior-design/interior-design-deco-bar-1.jpg" 
                                alt="DECO" 
                                class="w-100 d-block plax-img"/>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row class="pb-100">
                        <b-col cols="6" class="d-md-flex flex-column justify-content-between">
                             <div class="fade-in-up-element overflow-hidden mt-5 pr-md-5">
                                <nuxt-img provider="static" format="webp"
                                src="/img/interior-design/interior-design-deco-bar-2.jpg" 
                                alt="DECO" 
                                class="w-100 d-block plax-img"/>
                            </div>
                            <div class="fade-in-up-element overflow-hidden mt-5 pr-md-5">
                                <img
                                src="/img/interior-design/interior-design-welcome.jpg" 
                                alt="Welcome" 
                                class="w-100 d-block plax-img"/>
                            </div>
                        </b-col>
                        <b-col cols="6" class="d-md-flex flex-column justify-content-end pl-md-4">
                            <div class="fade-in-up-element overflow-hidden mt-md-5 mt-0">
                                <img
                                src="/img/interior-design/interior-design-deco.jpg" 
                                alt="Southport" 
                                class="w-100 d-block"/>
                            </div>
                        </b-col> 
                    </b-row>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
export default {
    data() {
        return {
            scrollSmoother_interiorDesign: null,
            textAnimation_interiorDesign: null,
            fadeInUpElement_interiorDesign: null,
            largeSlides: [
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-den.jpg",
                    alt: "Den"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-dining-2.jpg",
                    alt: "Dining Room"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-dining.jpg",
                    alt: "Dining Room"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-ensuite.jpg",
                    alt: "Ensuite"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-fireplace.jpg",
                    alt: "Fireplace"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-kitchen.jpg",
                    alt: "Dining and Kitchen area"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-living-room.jpg",
                    alt: "Living Room"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-family.jpg",
                    alt: "Family Room"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-dining-3.jpg",
                    alt: "Dining Room"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-deco-front-office.jpg",
                    alt: "DECO Homes front office"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-dining-4.jpg",
                    alt: "Dining Room"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-decor-boards.jpg",
                    alt: "Decor Boards"
                },
                {
                    img: "/img/interior-design/large-slider/interior-design-lg-slider-deco.jpg",
                    alt: "Deco"
                }
            ],
        }
    },
    components: {
        WhatWeDo: () => import('@/components/WhatWeDo'),
        WhereWeDoIt: () => import('@/components/WhereWeDoIt'),
        TextWheel3D: () => import('@/components/TextWheel3D'),
        InteriorDesignTabOne: () => import('@/components/InteriorDesign/InteriorDesignTabOne'),
        InteriorDesignTabTwo: () => import('@/components/InteriorDesign/InteriorDesignTabTwo'),
        SliderLarge: () => import('@/components/InteriorDesign/SliderLarge'),
        Transition1063: () => import('@/components/Transition1063'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_interiorDesign();
            // 
            this.initImgElReveal_interiorDesign();
        }, 500);
    },
    methods: {
        initscrollSmoother_interiorDesign() {
            this.scrollSmoother_interiorDesign = ScrollSmoother.create({
                wrapper: '#interiorDesign_wrapper',
                content: "#interiorDesign",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_interiorDesign.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_interiorDesign() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_interiorDesign = this.fadeInUpElement_interiorDesign;
                fadeInUpElement_interiorDesign = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_interiorDesign.set(container, { autoAlpha: 1 });
                fadeInUpElement_interiorDesign.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
    
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_interiorDesign.kill();
            console.log('ScrollTrigger killed in ' + this.$route.name)
        }, 500)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

#interiorDesign {
    .header {
        height: 100vh;
        min-height: 800px;

        @media screen and (max-width: 1199px) {
            height: auto;
            padding-bottom: 40px;
        }
    }

    .midbanner-text {
        position: absolute;
        bottom: 60px;
        right: 10vw;
    }

    .video-text-overlay {
        position: absolute;
        top: 30px;
        right: 30px;
    }

    .ga-circular-stamp {
        position: absolute;
        left: -164px;
        top: -137px;
        width: 100%;
        max-width: 280px;
        z-index: 1;

        @media screen and (max-width: 767px) {
            top: unset;
            bottom: 0;
        }
    }

    .ga-circular-stamp-2 {
        position: absolute;
        /* left: 0; */
        /* top: 0; */
        bottom: -150px;
        right: -80px;
        width: 100%;
        max-width: 280px;
        z-index: 1;

        @media screen and (max-width: 767px) {
            display: none;
        }
    }

    .lg-quotes {
        max-width: 60px;
    }

    .lg-text {
        font-size: 2.25vw;
    }

    img-comparison-slider {
        --divider-width: 1px;
        --divider-color: #000;
        --default-handle-color: #000;
        --handle-position-start: 50%;
        --default-handle-opacity: 1;
        outline: 0; 

        .img-slider-handle {
            background: #000;
            width: 14px;
            height: 14px;
            border-radius: 50%;
        }
    }
}


</style>